import { Image } from 'tiptap-extensions';

/**
 * TipTap v1 `Image` node extended with the two attributes the promo tools need:
 * a `width` (px or %) and an `align` (left | center | right).
 *
 * Both are serialised into inline styles so the stored HTML keeps rendering
 * correctly in the affiliate portal, in emails and inside the legacy Quill
 * viewers, none of which know about our attributes.
 */
export default class ResizableImage extends Image {
  get schema() {
    const base = super.schema;

    return {
      ...base,
      attrs: {
        ...base.attrs,
        width: { default: null },
        align: { default: null },
      },
      parseDOM: [
        {
          tag: 'img[src]',
          getAttrs: dom => ({
            src: dom.getAttribute('src'),
            alt: dom.getAttribute('alt'),
            title: dom.getAttribute('title'),
            width:
              dom.getAttribute('width')
              || (dom.style && dom.style.width ? dom.style.width.replace('px', '') : null),
            align: dom.getAttribute('data-align') || null,
          }),
        },
      ],
      toDOM: (node) => {
        const { width, align, ...rest } = node.attrs;
        const style = [
          width ? `width:${/%$/.test(String(width)) ? width : `${width}px`}` : '',
          align === 'center'
            ? 'display:block;margin-left:auto;margin-right:auto'
            : align
              ? `float:${align};margin:0 12px 8px 0`
              : '',
        ]
          .filter(Boolean)
          .join(';');

        return [
          'img',
          {
            ...rest,
            width: width || null,
            'data-align': align || null,
            style: style || null,
          },
        ];
      },
    };
  }

  /**
   * The stock Image extension ships a ProseMirror plugin that turns dropped
   * files into base64 data URLs. GsRichTextEditor uploads dropped images
   * instead, so the built-in handler is disabled to avoid a double insert.
   */
  get plugins() {
    return [];
  }
}
